import React from 'react'
// layers
import ActivitiesListAPI from 'containers/Activities/layers/API/ActivitiesList'
import ActivitiesListBL from 'containers/Activities/layers/BL/ActivitiesList'
import ResourcesListBL from 'containers/Activities/layers/BL/ResourcesList'
// components
import ActivitiesList from 'components/Modals/PlanItems/components/ActivitiesList'

const ActivitiesListContainer = props => (
  <ActivitiesListAPI {...props}>
    <ActivitiesListBL {...props}>
      <ResourcesListBL>
        <ActivitiesList {...props} />
      </ResourcesListBL>
    </ActivitiesListBL>
  </ActivitiesListAPI>
)

export default ActivitiesListContainer
